import React from 'react';
import styled from "styled-components";
import DoneGif from "@molecules/lotties/done_gif";
import FailGif from "@molecules/lotties/fail_gif";

/**
 * @param {string} text
 * @param {string} status => done||cancel
 * @param className
 */

const StatusGit = ({text, status = 'done', className}) => {
    return (
        <Container className={(className ?? '')}>
            {
                (status === 'done') ?
                    <DoneGif width={150} height={150}/>
                    :
                    <FailGif width={150} height={150}/>
            }

            <h4 className="font-weight-normal" dangerouslySetInnerHTML={{__html: text}}/>

        </Container>
    );
};

export default StatusGit;

// styles

const Container = styled.div`
    img {
        height: 150px;
    }
`;